<template>
  <div id="app">
    <main class="App__main">
      <transition name="slide" @scroll="screenTop" appear>
        <header-prismic/>
      </transition>
        <router-view/>

    </main>
    <!--footer-prismic/-->
  </div>
</template>

<script>
import HeaderPrismic from "./components/HeaderPrismic.vue";
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import {Carousel, Slide} from 'vue-carousel';

//import VueMeta from 'vue-meta';

export default {
  name: 'App',

  metaInfo: {
    title: 'Magento 2 Webshop & Prismic Website specialist  ',
    titleTemplate: '%s - Falcon Media',
    htmlAttrs: {
      amp: true
    }
  },
  components: {
    HeaderPrismic,
    VueSlider,
    Carousel,
    Slide,
  //  VueMeta,
  },
  methods: {
    screenTop() {},
  }
}


</script>

<style lang="scss">
@import "./assets/css/resetr.css";
@import "./assets/css/common.css";
@import url('https://fonts.googleapis.com/css2?family=Concert+One&family=Muli:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400&family=Nanum+Gothic&display=swap');
@import url(https://fonts.googleapis.com/icon?family=Material+Icons);
</style>
